/* unplugin-vue-components disabled */import script from "./NavigatorBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigatorBar.vue?vue&type=script&setup=true&lang=js"

import "./NavigatorBar.vue?vue&type=style&index=0&id=251f0b02&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251f0b02"]])

export default __exports__